import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/unerry-logo-g.svg'
import _imports_1 from '@/assets/noun-alert.svg'


const _withScopeId = n => (_pushScopeId("data-v-961d9ade"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "place-container" }
const _hoisted_2 = {
  key: 0,
  class: "display-name"
}
const _hoisted_3 = { class: "date" }
const _hoisted_4 = {
  key: 1,
  class: "notice"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "※スポット近辺の推定混雑状況です。", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "chart-container" }
const _hoisted_8 = {
  key: 2,
  class: "last-update"
}
const _hoisted_9 = {
  key: 3,
  class: "site-link"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.unerry.co.jp/service/customize-congestion-map/",
  target: "_blank",
  rel: "noopener"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "not-found"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"elements\" data-v-961d9ade><img src=\"" + _imports_1 + "\" data-v-961d9ade><p data-v-961d9ade>カスタマイズ混雑マップへの<br data-v-961d9ade>スポット登録がありません</p></div><div class=\"site-link\" data-v-961d9ade><a href=\"https://www.unerry.co.jp/service/customize-congestion-map/\" target=\"_blank\" rel=\"noopener\" data-v-961d9ade><span data-v-961d9ade>Powered by</span><img src=\"" + _imports_0 + "\" data-v-961d9ade></a></div>", 2)
const _hoisted_15 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.place)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["place", {
        'with-display_name': _ctx.place.display_name,
        'with-credit': _ctx.showCredit,
      }])
        }, [
          (_ctx.place.display_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.place.display_name), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["status", _ctx.statusClass(_ctx.currentStatus)]),
            style: _normalizeStyle(_ctx.statusStyle(_ctx.currentStatus))
          }, [
            _createElementVNode("p", null, [
              _createTextVNode(" [" + _toDisplayString(_ctx.statusDetailHeader(_ctx.currentStatus)) + "] " + _toDisplayString(_ctx.statusDetailLabel(_ctx.currentStatus)) + " ", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.lastUpdatedLabel), 1)
            ])
          ], 6),
          (_ctx.showCredit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.congestions)
              ? (_openBlock(), _createBlock(_component_Chart, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.lastUpdateDateTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, "最終更新 : " + _toDisplayString(_ctx.lastUpdateDateTime), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showCredit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}